import { createSlice } from '@reduxjs/toolkit';
import { API_STATUS_TYPE } from '../../../utils/contants';
import { addContent, fetchWebContentByType } from './webContentThunk';

const INITIAL_STATE = {
    isLoading: false,
    error: null,
    status: API_STATUS_TYPE.IDLE,
    contents:[],
    currentContent:null
}

const webContentSlice = createSlice({
  name: 'WEB_CONTENT_SLICE',
  initialState: INITIAL_STATE,
  extraReducers: (builder) => {
    builder
    .addCase(addContent.fulfilled, (state, action) => {
        state.isLoading = false
        state.status = API_STATUS_TYPE.SUCCESSED
    })

    .addCase(fetchWebContentByType.fulfilled, (state, action) => {
        state.isLoading = false
        state.status = API_STATUS_TYPE.SUCCESSED
        const item = action.payload.data
        const webContentMap = {
          ...item,
          translationsMap: Array.isArray(item.translations)
            ? item.translations.reduce((acc, t) => {
                if (t && t.languageCode) {
                  acc[t.languageCode] = {
                    title: t.title ?? '',
                    description: t.description ?? ''
                  };
                }
                return acc;
              }, {})
            : {}
            }
          state.currentContent = webContentMap
    })
      /* 2. MATCHERS ALWAYS GO AFTER CASES */
      // Pending Matcher
      .addMatcher(
        (action) => action.type.startsWith('webContent/') && action.type.endsWith('/pending'),
        (state) => {
          state.isLoading = true;
          state.status = API_STATUS_TYPE.PENDING;
          state.error = null;
        }
      )

      // Rejected Matcher
      .addMatcher(
        (action) => action.type.startsWith('webContent/') && action.type.endsWith('/rejected'),
        (state, action) => {
          state.isLoading = false;
          state.status = API_STATUS_TYPE.FAILED;
          state.error = action?.payload || 'An unexpected error occurred';
        }
      );
  }
});

export default webContentSlice.reducer